import Script from 'next/script'
import { Container } from '../components/Container'
import HeroHeader from '../components/HeroHeader'
import EmbedHubSpotForm from '../components/EmbedHubSpotForm'
import { GeneralAPI } from '../apis/GeneralAPI'

export default function ContactUs({ data }) {
    return (
        <>
            <Script
                src="//js.hsforms.net/forms/embed/v2.js"
                strategy="afterInteractive"
            />
            <HeroHeader title="Contact Us" meta={data?.yoast_head} />

            {/* Centered HubSpot Form */}
            <Container>
                <div className="pt-4 pb-8">
                    <h2 className="mb-6 text-center text-2xl font-bold text-olm-black">
                        Send us a message
                    </h2>
                    <div className="flex justify-center">
                        <div className="w-full max-w-xl">
                            <div
                                id="hubspotForm"
                                className="sr-only"
                                aria-hidden="true"
                            />
                            <EmbedHubSpotForm
                                portalId="21994206"
                                formId="59c64e6e-8306-47a7-b1d8-852e67613988"
                                formName="Contact us"
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/contact-us')
    const data = page ? page[0] : {}

    return { props: { data }, revalidate: 10 }
}
